import React from 'react'
import { GIFT_CARDS } from '../../paths'
import { LinkSectionPropsType, LinkSection } from './link-section'
import { CentreDetails } from './centre-details'
import * as paths from './paths'
import style from './index.module.scss'
import { trackUniversalFooterLinkClick } from './analytics'

const customerSupport = {
  text: 'Customer Support',
  url: paths.CUSTOMER_SUPPORT,
}
const westfieldDirect: LinkSectionPropsType = {
  heading: { text: 'Westfield Direct', url: paths.WESTFIELD_DIRECT },
  links: [
    { text: 'About Westfield Direct', url: paths.SHOP_ABOUT, newTab: true },
    {
      text: 'Click & Collect',
      url: paths.SHOP_CLICK_COLLECT,
      newTab: true,
    },
    { text: 'Delivery', url: paths.SHOP_DELIVERY, newTab: true },
    { text: 'Returns', url: paths.SHOP_RETURNS, newTab: true },
    { text: 'Rewards', url: paths.SHOP_REWARDS, newTab: true },
    { text: 'Size guide', url: paths.SHOP_SIZE_GUIDE, newTab: true },
    {
      text: 'Terms and conditions',
      url: paths.TERMS_CONDITIONS_WESTFIELD_DIRECT,
      newTab: false,
    },
    {
      text: 'Privacy statement',
      url: paths.PRIVACY_POLICY_WESTFIELD_DIRECT,
      newTab: false,
    },
    { text: 'FAQs', url: paths.FAQS, newTab: true },
  ],
}
const giftCards: LinkSectionPropsType = {
  heading: { text: 'Westfield Gift Cards', url: GIFT_CARDS },
  links: [
    {
      text: 'Gift Cards Terms & Conditions',
      url: paths.GIFT_CARDS_TC,
    },
    { text: 'FAQs', url: paths.FAQS, newTab: true },
  ],
}

export const LeftColumnContainer: React.FC<{
  centre?: React.ComponentProps<typeof CentreDetails>['centre']
  country: string
  onFindACentre?: () => void
}> = ({ centre, country, onFindACentre }) => (
  <div className={style.leftColumnContainer}>
    <div className={style.footerGroup}>
      {centre ? (
        <CentreDetails centre={centre} onFindACentre={onFindACentre} />
      ) : (
        onFindACentre && (
          <div className={style.findCentre}>
            <LinkSection
              heading={{ text: 'Find a centre', onClick: onFindACentre }}
              trackers={{ clicked: trackUniversalFooterLinkClick }}
            />
          </div>
        )
      )}
      {country === 'Australia' && (
        <LinkSection
          heading={customerSupport}
          trackers={{ clicked: trackUniversalFooterLinkClick }}
        />
      )}
    </div>
    {country === 'Australia' && (
      <>
        <div className={style.footerGroup}>
          <LinkSection
            heading={westfieldDirect.heading}
            links={westfieldDirect.links}
            trackers={{ clicked: trackUniversalFooterLinkClick }}
          />
        </div>
        <div className={style.footerGroup}>
          <LinkSection
            heading={giftCards.heading}
            links={giftCards.links}
            trackers={{ clicked: trackUniversalFooterLinkClick }}
          />
        </div>
      </>
    )}
  </div>
)
